import React from 'react';

const ContractCard = ({ contract }) => {
  return (
    <div className="contract-card">
      <div className="contract-header">
        <div>
          <div className="contract-customer">Contact: {contract.contact_id}</div>
          <div className="contract-mandante">{contract.list_name || contract.list_id} · {contract.campaign_id}</div>
        </div>
        <span className={`badge ${contract.status === 'OK' ? 'badge-risk-low' : 'badge-default'}`}>
          {contract.status}
        </span>
      </div>
      <div className="contract-meta">
        <span className="contract-meta-item">📋 Lista: {contract.list_id}</span>
        <span className="contract-meta-item">📅 {new Date(contract.timestamp).toLocaleString('it-IT')}</span>
      </div>
    </div>
  );
};

export default ContractCard;
